import React, { useState } from "react";
import { uploadClubPhoto } from "../lib/data";
import { FF, T } from "../lib/constants";
import { LibIcon } from "./ui";

export default function PhotoUploader({ clubId, photo, onChange }) {
  var [uploading, setUploading] = useState(false);
  async function handleFile(e) {
    var file = e.target.files[0]; if (!file) return;
    setUploading(true);
    try { var url = await uploadClubPhoto(clubId, file); onChange(url); }
    catch (err) { console.error(err); alert("Upload mislukt."); }
    setUploading(false);
    e.target.value = "";
  }
  var btn = { minHeight: 36, padding: "0 12px", borderRadius: 8, fontSize: 13, fontWeight: 700, fontFamily: FF, display: "inline-flex", alignItems: "center", gap: 6, boxSizing: "border-box" };
  return (
    <div style={{ padding: "10px 14px", display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
      <label style={Object.assign({}, btn, { background: uploading ? "#8A857B" : "#fff", color: uploading ? "#fff" : T.primary, border: "1px solid " + T.line, cursor: uploading ? "default" : "pointer" })}>
        <LibIcon name="image" size={16} />{uploading ? "Uploaden..." : (photo ? "Andere foto" : "Foto toevoegen")}
        <input type="file" accept="image/*" onChange={handleFile} disabled={uploading} style={{ display: "none" }} />
      </label>
      {photo && <button type="button" onClick={function () { onChange(""); }} style={Object.assign({}, btn, { background: "#fff", border: "1px solid " + T.line, color: "#B83232", cursor: "pointer" })}>Foto verwijderen</button>}
    </div>
  );
}
